import { fromXML } from "from-xml";
import { XMLNode } from "./XMLNode";

const proxyHandler = {
    get(target: XMLNode, name: any): XML {
        let attrType = typeof (target[name]);

        if (
            name === "_data" ||
            attrType === "function" ||
            attrType === "object" ||
            attrType === "number"
        ) {
            return target[name];

        } else if (typeof (name) === "string") {
            if (name.indexOf("@") === 0) {
                return target.attribute(name.substr(1));

            } else {
                if ((<any>target)._data[name] !== undefined) {
                    let child = target.child(name);

                    if (isPrimitiveType((<any>child)._data)) {
                        let data = (<any>child)._data;
                        return (data !== null) ? data : "";

                    } else {
                        return child;
                    }

                } else if ((<any>target)._data[`@${name}`] !== undefined) {
                    return target.attribute(name);

                } else {
                    // console.warn(`XML: '${name}' is not available.`);
                    return undefined;
                }

            }
        }

        return target[name];
    }
}

export function createNodeProxy(data: any, parent: any = null): XMLNode & any {
    return new Proxy<XMLNode>(new XMLNode(data, parent), proxyHandler);
}

export function XML(xml: string) {
    let data = fromXML(xml);
    let xmlData = data;

    // get root node
    for (let i in data) {
        if (i.match(/[A-Za-z\-]+/)) {
            xmlData = data[i];
            break;
        }
    }

    return createNodeProxy(xmlData);
}

function isPrimitiveType(value: any): boolean {
    return (
        value === null ||
        typeof (value) === "string" ||
        typeof (value) === "number" ||
        typeof (value) === "boolean"
    )
}

export type XML = XMLNode & any;
export type XMLList = XML[] | XML;
